import firebase from 'firebase/app'

export default{

	actions: {

			async fetchCategories({commit, dispatch},) {
				//тк ектион асинхронный оберуть в трай сетч
			//метод диспатч импортируется для того чтобы получить  йд пользователя
			try {
				//создадим переменную подождав пока диспатч получит юйди
				const uid = await dispatch('getUid')

				//once('value') возвращает новый объект у которого есть функция val котор позв получить данные из базы	
				//если ничего не возвр будет пустой объект {}
				 
				const categories = (await firebase.database().ref(`/users/${uid}/categories`).once('value')).val() || {}
				 

				 // console.log(categories)
				 //с помощью функции пробежаться по массиву и вернет массив ключей
				 
				 // const cats = []
				 // Object.keys(categories).forEach(key => {
				 // 	cats.push({
				 // 		title: categories[key].title,
				 // 		limit: categories[key].limit,
				 // 		id: key
				 // 	})
				 // })
				 // return cats
				 // так не очень красиво можно более локанично
				 return Object.keys(categories).map(key => ({...categories[key], id: key}))
				}catch (e){
				// обратиться к методу коммит и обр ошибку через  мутатион сет еррор
				// куда передаем ошибку е, котор находится в индекс жс
				commit('setError', e)
				// если будет ошибка
				throw e

			}
			},
			async fetchCategoryById({commit, dispatch}, id) {
			try {
			 	const uid = await dispatch('getUid')
		 
				const category = (await firebase.database().ref(`/users/${uid}/categories`).child(id).once('value')).val() || {}
			
				 return {...category, id}
				}catch (e){
				 
				commit('setError', e)
				 
				throw e

			}
			},
			async updateCategory({commit, dispatch}, {title, limit, id}){
				try {
				 
				const uid = await dispatch('getUid')
				 
 				 await firebase.database().ref(`/users/${uid}/categories`).child(id).update({title, limit})
				 

			}catch (e){
				commit('setError', e)
				throw e
			}
			},
	//принимате параметры передаваемые при вызове
		async createCategory({commit, dispatch}, {title, limit}) {
			//тк ектион асинхронный оберуть в трай сетч
			//метод диспатч импортируется для того чтобы получить  йд пользователя
			try {
				//создадим переменную подождав пока диспатч получит юйди
				const uid = await dispatch('getUid')

				//если поле категорис не существ фб его создаст
				//пуш для созд новой категории, где будет поле тайтл и лимит
				//после этот фб вернет опред категорию где также будет поле кей автоматич сгенерированное
				//будет использ как айди и совпадать с category.key
				
				 
				const category = await firebase.database().ref(`/users/${uid}/categories`).push({title, limit})
				return {title, limit, id: category.key}



			}catch (e){
				// обратиться к методу коммит и обр ошибку через  мутатион сет еррор
				// куда передаем ошибку е, котор находится в индекс жс
				commit('setError', e)
				// если будет ошибка
				throw e

			}

		}
	}
}